/**
 * Convertir un cuestionario en un archivo de intercambio.
 *
 * El resultado tiene que poder **reimportarse produciendo un cuestionario equivalente** (CE-004),
 * y tiene que ser legible y editable por una persona: el mismo archivo que un modelo de lenguaje
 * escribe, alguien puede querer corregirlo a mano.
 */
import { SUPPORTED_FORMAT_VERSION } from './schema.js';
/**
 * Construye el archivo.
 *
 * Los campos que valen nulo **se omiten** en lugar de escribirse como nulos: nulo significa
 * «hereda», y omitirlo es exactamente lo que el importador entiende como tal. Escribir `null`
 * obligaría al importador a distinguir entre «ausente» y «nulo» sin que la diferencia signifique
 * nada.
 */
export function buildExchangeFile(quiz, exportedAt) {
    return {
        clica_format: SUPPORTED_FORMAT_VERSION,
        exported_at: exportedAt,
        quiz: {
            title: quiz.title,
            ...(quiz.description === null ? {} : { description: quiz.description }),
            ...(Object.keys(quiz.default_settings).length === 0
                ? {}
                : { settings: quiz.default_settings }),
            questions: quiz.questions.map((question) => ({
                type: question.type,
                prompt: question.prompt_md ?? '',
                ...(question.hint_md === null ? {} : { hint: question.hint_md }),
                ...(question.time_limit_s === null ? {} : { time_limit_s: question.time_limit_s }),
                ...(question.hint_after_s === null ? {} : { hint_after_s: question.hint_after_s }),
                ...(question.shuffle_options === null ? {} : { shuffle_options: question.shuffle_options }),
                ...(question.points_multiplier === null
                    ? {}
                    : { points_multiplier: question.points_multiplier }),
                options: question.options.map((option) => ({
                    text: option.text_md ?? '',
                    correct: option.is_correct,
                })),
            })),
        },
    };
}
/** El archivo como texto, con sangría para que se pueda leer y editar. */
export function serializeExchangeFile(quiz, exportedAt) {
    return `${JSON.stringify(buildExchangeFile(quiz, exportedAt), null, 2)}\n`;
}
/**
 * Un nombre de archivo reconocible, derivado del título (RF-017).
 *
 * Se conservan las letras acentuadas y la eñe: el archivo lo va a buscar una persona en su
 * carpeta de descargas, y «cinemática» se encuentra mejor que «cinematica».
 */
export function exchangeFileName(title) {
    const slug = title
        .trim()
        .toLowerCase()
        .replace(/[\s/\\:*?"<>|]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    return `${slug === '' ? 'cuestionario' : slug}.clica.json`;
}
//# sourceMappingURL=export.js.map